import React, { useState } from 'react'
import { Collapse } from 'react-bootstrap'
import { getI18nText } from '../../services/i18nService'

const TechnicalDetails = ({ microcopy, technicalDetails }) => {
  const [technicalDetailsOpen, setTechnicalDetailsOpen] = useState(true)

  return (
    <div className="product-details__product-data--item" id="tech">
      <p className="product-details__product-data--header font__heavy" id="button-tech">
        <button
          className={`product-details__product-data--button ${
            technicalDetailsOpen ? '' : 'collapsed'
          }`}
          type="button"
          aria-expanded={technicalDetailsOpen}
          onClick={() => setTechnicalDetailsOpen(!technicalDetailsOpen)}
          aria-controls="body-tech"
        >
          {getI18nText(microcopy, 'product.technicaldetails')}
        </button>
      </p>
      <Collapse in={technicalDetailsOpen}>
        <div
          id="body-tech"
          className="product-details__product-data--collapse"
          aria-labelledby="button-tech"
        >
          <div className="product-details__product-data--body">
            <div className="product-details__product-data--table d-flex">
              <table>
                <tbody>
                  {technicalDetails !== null &&
                    technicalDetails !== undefined &&
                    Object.keys(technicalDetails).map((key) => {
                      return (
                        <tr key={key}>
                          <th>{key}</th>
                          <td>{technicalDetails[key]}</td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default TechnicalDetails
